const setting = {
    securitySetting: 'Security setting',
    resetPassword: 'Reset password',
    resetPasswordDescription: 'Password current reset'
}
export default setting